// extracted by mini-css-extract-plugin
module.exports = {"table":"tables_table__23PGg","tableBodyWrapper":"tables_tableBodyWrapper__oCJRb"};